module.exports = __webpack_public_path__ + "img/ArgCroacia7.71e34e38.jpg";